import requestPassport  from '../services/requestPassport';
import requestClubv2  from '../services/requestClubv2';

// 账号登录
export function do_login(data) {
  return requestPassport({
    url: `/index.php`,
    method: "post",
    data: { ...data, c: "loginnew", m: "login" },
  });
}

// 验证码发送
export function login_sms_code(data) {
  return requestPassport({
    url: `/index.php`,
    method: "post",
    data: { ...data, c: "loginnew", m: "login_sms_code" },
  });
}


// 手机号登录
export function login_by_mobile(data) {
  return requestPassport({
    url: `/index.php`,
    method: "post",
    data: { ...data, c: "loginnew", m: "login_by_mobile" },
  });
}

// 签到
export function sign_up_everyday(data) {
  return requestClubv2({
    url: `/index.php?c=user/user&m=sign_up`,
    method: "post",
    data,
  });
}

// 验证用户名
export function check_user_name(data) {
  return requestPassport({
    url: `/index.php`,
    method: "post",
    data: { ...data, c: "registernew", m: "check_user_name" },
  });
}

// 注册验证码
export function register_sms_code(data) {
  return requestPassport({
    url: `/index.php`,
    method: "post",
    data: { ...data, c: "registernew", m: "register_sms_code" },
  });
}


// 手机号注册
export function register_phone(data) {
  return requestPassport({
    url: `/index.php`,
    method: "post",
    data: { ...data, c: "registernew", m: "register" },
  });
}


// 找回密码验证码
export function findnewpwd_send_sms_code(data) {
  return requestPassport({
    url: `/index.php`,
    method: "post",
    data: { ...data, c: "findnewpwd", m: "send_sms_code" },
  });
}

// 找回密码验证码验证
export function findnewpwd_check_sms_code(data) {
  return requestPassport({
    url: `/index.php`,
    method: "post",
    data: { ...data, c: "findnewpwd", m: "check_sms_code" },
  });
}

// 找回密码修改密码
export function findnewpwd_new_password(data) {
  return requestPassport({
    url: `/index.php`,
    method: "post",
    data: { ...data, c: "findnewpwd", m: "do_modify_password" },
  });
}


// 找回账号验证码
export function findnewact_send_sms_code(data) {
  return requestPassport({
    url: `/index.php`,
    method: "post",
    data: { ...data, c: "findnewact", m: "send_sms_code" },
  });
}

// 找回账号获取用户信息
export function findnewact_check_sms_code(data) {
  return requestPassport({
    url: `/index.php`,
    method: "post",
    data: { ...data, c: "findnewact", m: "check_sms_code" },
  });
}

// 找回账号且登录
export function findnewact_new_account(data) {
  return requestPassport({
    url: `/index.php`,
    method: "post",
    data: { ...data, c: "findnewact", m: "login" },
  });
}


// 微信扫一扫后获取信息
export function user_pre_bind_info(data) {
  return requestPassport({
    url: `/index.php`,
    method: "post",
    data: { ...data, c: "loginnew", m: "user_pre_bind_info" },
  });
}

// 绑定已有账户
export function do_bind_login_info(data) {
  return requestPassport({
    url: `/index.php`,
    method: "post",
    data: { ...data, c: "loginnew", m: "do_bind_login_info" },
  });
}


// 绑定新账号发送验证码
export function get_bind_info_sms_code(data) {
  return requestPassport({
    url: `/index.php`,
    method: "post",
    data: { ...data, c: "loginnew", m: "get_bind_info_sms_code" },
  });
}


// 微信注册
export function do_bind_register_info(data) {
  return requestPassport({
    url: `/index.php`,
    method: "post",
    data: { ...data, c: "loginnew", m: "do_bind_register_info" },
  });
}


// 账号查找
export function find_account(data) {
  return requestPassport({
    url: `/index.php`,
    method: "post",
    data: { ...data, c: "findnewact", m: "find_account" },
  });
}

// 手机号验证码
export function send_sms_code_retrieve(data) {
  return requestPassport({
    url: `/index.php`,
    method: "post",
    data: { ...data, c: "findnewact", m: "send_sms_code_retrieve" },
  });
}

// 手机号验证
export function check_sms_code_retrieve(data) {
  return requestPassport({
    url: `/index.php`,
    method: "post",
    data: { ...data, c: "findnewact", m: "check_sms_code_retrieve" },
  });
}

// 邮箱验证码
export function send_email_code_retrieve(data) {
  return requestPassport({
    url: `/index.php`,
    method: "post",
    data: { ...data, c: "findnewact", m: "send_email_code_retrieve" },
  });
}

// 邮箱验证
export function check_email_code_retrieve(data) {
  return requestPassport({
    url: `/index.php`,
    method: "post",
    data: { ...data, c: "findnewact", m: "check_email_code_retrieve" },
  });
}

// 修改密码
export function do_modify_password(data) {
  return requestPassport({
    url: `/index.php`,
    method: "post",
    data: { ...data, c: "findnewact", m: "do_modify_password" },
  });
}